<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents"><span>Contents</span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0001#auto_bookmark_table_of_contents_1">Book Description</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0002#auto_bookmark_table_of_contents_1">Title Page</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0004#auto_bookmark_table_of_contents_1">Introduction</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0004#auto_bookmark_table_of_contents_2">Cloning Mammoths</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0005#auto_bookmark_table_of_contents_1">Mammoth Dawn</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0005#auto_bookmark_table_of_contents_2">The Original Novella</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0006#auto_bookmark_table_of_contents_1">Mammoth Dawn</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0006#auto_bookmark_table_of_contents_2">Full Novel Treatment and Proposal</a></span></p>
<p class="P_TOC_Entry_3"><span><a href="#/section0006#auto_bookmark_table_of_contents_3">Overview</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0006#auto_bookmark_table_of_contents_4">Scientific Basis—Why Mammoths? Why Now?</a></span></p>
<p class="P_TOC_Entry_3"><span><a href="#/section0006#auto_bookmark_table_of_contents_5">Prologue—The Hunt</a></span></p>
<p class="P_TOC_Entry_3"><span><a href="#/section0006#auto_bookmark_table_of_contents_6">Part I—Mammoth Ranch</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0006#auto_bookmark_table_of_contents_7">Part II—The Resurrection Preserve</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0006#auto_bookmark_table_of_contents_8">Part III—Survival of the Fittest</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0006#auto_bookmark_table_of_contents_9">Part IV—Pleistocene Rules</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0006#auto_bookmark_table_of_contents_10">Bringing Back the Mammoths</a></span></p>
<p class="P_TOC_Entry_3"><span><a href="#/section0006#auto_bookmark_table_of_contents_11">Why?</a></span></p>
<p class="P_TOC_Entry_3"><span><a href="#/section0006#auto_bookmark_table_of_contents_12">How?</a></span></p>
<p class="P_TOC_Entry_3"><span><a href="#/section0006#auto_bookmark_table_of_contents_13">When?</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0007#auto_bookmark_table_of_contents_1">About the Authors</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0008#auto_bookmark_table_of_contents_1">If You Liked …</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0009#auto_bookmark_table_of_contents_1">Other WordFire Press Titles</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0003.vue?efa608f4